// import { Component, OnInit } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';
// import { CollectionService } from '../ApplicationServices/CollectionService';
// import { ProductTile } from '../models/product-tile.model';
import { SearchFilterPipe } from '../search-filter/search-filter.pipe';

import { Component, OnInit } from "@angular/core";
import { ProductTile } from "../models/product-tile.model";
import { ActivatedRoute, Router } from "@angular/router";
import { CollectionService } from "../ApplicationServices/CollectionService";
import { ProductDetailsService } from '../ApplicationServices/ProductDetailsService';
import { ItemModifierService } from "src/app/ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {

  // searchKey: string = '';
  // itemData: any;
  // options: any[] = [];
  // filteredOptions1: any[];

  CATEGORY :String=null;
  SUBCATEGORY :String=null;

  _SKUCODE_ :String=null;

  productTileList: ProductTile[] = [];
  //productList: ProductTile[] = [];
  collectionServ: CollectionService = null;
  //productListAvailable = false;
  private sub: any;
  currentQuickView:ProductTile;
  showQuickView:boolean=false;
  detailedService: ProductDetailsService;

  productListAvailable: boolean = null;
  productList: ProductTile[] = [];

  
  total:0;
  range='0'

  constructor(

    
    private route: ActivatedRoute,
    private router: Router,
    private collectionService: CollectionService,
    private detailService: ProductDetailsService,
    private itemModifierService: ItemModifierService,
    private infoStore: UserInfoStore
    
    
    ) {

      this.collectionServ = collectionService;
      this.detailedService = detailService;

      this.route.queryParams.subscribe((val) => {
      if(val.searchKey) {
        this.GetAllProductsBySearchKeywordsWords(val.searchKey);
      }
      })


  }

  ngOnInit()
  {

    
    // this.sub = this.route.params.subscribe((params) => {
    //   this.productListAvailable = false;
    //   var arg = params["itemCategory"];
    //   const itemName = arg.split("&")[1];
    //   const itemCategory = arg.split("&")[0];
    //   switch (itemCategory) {

    //     case "Men":
    //       this.collectionServ
    //         .getAllMENSCOLLECTION_NAMEData(itemName)
    //         .subscribe((data: any) => this.manageRes(data));
    //         this.CATEGORY="Mens Collections";
    //         this.SUBCATEGORY=itemName;
    //       break;
    //     case "Women":
    //       this.collectionServ
    //         .getAllWOMENSCOLLECTION_NAMEData(itemName)
    //         .subscribe((data: any) => this.manageRes(data));
    //          this.CATEGORY="Womens Collections";
    //          this.SUBCATEGORY=itemName;
    //       break;
    //     case "Uni":
    //       this.collectionServ
    //         .getAllUNISEXCOLLECTION_NAMEData(itemName)
    //         .subscribe((data: any) => this.manageRes(data));
    //         this.CATEGORY="Unisex Collections";
    //         this.SUBCATEGORY=itemName;
    //       break;
    //     case "Others":
    //       this.collectionServ
    //         .getAllOTHERSCOLLECTION_NAMEData(itemName)
    //         .subscribe((data: any) => this.manageRes(data));
    //         this.CATEGORY="Others Collections";
    //         this.SUBCATEGORY=itemName;
    //       break;
          
    //     default:
    //       break;
    //   }
    // });


    this.route.queryParams.subscribe((val) => {
      if(val.searchKey) {
        this.GetAllProductsBySearchKeywordsWords(val.searchKey);
      }
      })


    if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

      this.infoStore.setCartInfo([]);
      sessionStorage.clear();
      this.infoStore.setInfo({});

     alert("Session Expired , Please Login  !!");
     this.router.navigateByUrl("login");

     }



  }

  GetAllProductsBySearchKeywordsWords(searchKey) {
    this.productListAvailable = true;
    this.collectionService.GetAllProductsBySearchKeywordsWords(searchKey).subscribe(
      (data: any) => {

        this.productListAvailable = false;
        this.productList = data;


        this.productList = [];
        this.total=data.length
        this.range=`1 - ${data.length}`
        for (let index = 0; index < data.length; index++) {
          let prod = new ProductTile();
          prod=data[index];
          // prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
          prod.HotLabel = data[index].PrimaryTagName;
          // prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";
          prod.ProductTileImgURL1 = data[index].img1; //"../../../assets/styles/images/books/1.jpg";
          prod.ProductTileImgURL2 = data[index].img2; //"../../../assets/styles/images/books/1.jpg";
          prod.ProductBlockImgURL = data[index].img3; //"../../../assets/styles/images/product/2.jpg";
          prod.ProductName = data[index].ItemName; //"robin parrish";
          prod.ProductURL = "#/single-product";
          prod.ItemId = data[index].ItemId;
          prod.SKUCode= data[index].SKUCode;
          this._SKUCODE_= data[index].SKUCode;
          prod.ProductDescription =
          "Designed for simplicity and made from high quality materials."+
          "Its sleek geometry and material combinations creates a modern look"+
          "- the ultimate look you desire for.";
    
          prod.CollectionName = "PRODUCT";
    
          if(  data[index].PriceCaption == null || data[index].PriceCaption == "" )
          {
    
            // this.CAP=true;
    
            prod.CurrentPrize = "Rs."+" "+  data[index].StrikePrice; //"$35.00";
            prod.OldPrize ="Rs."+" "+  data[index].MaxRetailPrice; //"$55.00";          
                
    
          }
          else
          {
    
              // this.CAP=false;
             //prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
            //prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";          
            
              
            prod.CurrentPrize = data[index].StrikePrice; //"$35.00";
            prod.OldPrize = ""; //"$55.00"; 
        
    
          }
    
       
    
          this.productList.push(prod);
    
        }
    
        this.productListAvailable = true;


      },
      (error) => {
        console.log(error);
      }
    )
  }


  
  
  addToCart1() {

    //  if( this._Status_=='QV' ){

    //   this._SKUCODE_=this._SKUCODEQ_;

    //  }
    //  else  if( this._Status_=='GE' )
    //  {

    //   this._SKUCODE_=this._SKUCODEG_;

    //  }

    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        ApplicationItemCategoryId: 4,
        OrderStatusID: 2,
        OrderShippingCategoryID: 0,
        OrderPaymentTypeId: 0,
        PackingId: 0,
        TrackId: 0,
        SKUCode: this._SKUCODE_,
        Qty: 1,
        CreatedBy: 55,
        OperationType: "insert",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Saved") {
            alert("Add To Cart Successfully !");
            this.getCartInfo();
          }
        }
      });
    } else {
      alert("Please Login !!");
      this.router.navigateByUrl("login");
    }
  }

  getCartInfo() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    } else {
      this.infoStore.setCartInfo([]);
    }
  }

  manageRes(data: any) {

    this.productList = [];
    this.total=data.length
    this.range=`1 - ${data.length}`
    for (let index = 0; index < data.length; index++) {
      let prod = new ProductTile();
      prod=data[index];
      // prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
      prod.HotLabel = data[index].PrimaryTagName;
      // prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";
      prod.ProductTileImgURL1 = data[index].img1; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductTileImgURL2 = data[index].img2; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductBlockImgURL = data[index].img3; //"../../../assets/styles/images/product/2.jpg";
      prod.ProductName = data[index].ItemName; //"robin parrish";
      prod.ProductURL = "#/single-product";
      prod.ItemId = data[index].ItemId;
      prod.SKUCode= data[index].SKUCode;
      this._SKUCODE_= data[index].SKUCode;
      prod.ProductDescription =
      "Designed for simplicity and made from high quality materials."+
      "Its sleek geometry and material combinations creates a modern look"+
      "- the ultimate look you desire for.";

      prod.CollectionName = "PRODUCT";

      if(  data[index].PriceCaption == null || data[index].PriceCaption == "" )
      {

        // this.CAP=true;

        prod.CurrentPrize = "Rs."+" "+  data[index].StrikePrice; //"$35.00";
        prod.OldPrize ="Rs."+" "+  data[index].MaxRetailPrice; //"$55.00";          
            

      }
      else
      {

          // this.CAP=false;
         //prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
        //prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";          
        
          
        prod.CurrentPrize = data[index].StrikePrice; //"$35.00";
        prod.OldPrize = ""; //"$55.00"; 
    

      }



      // if( this.CATEGORY=="Others" ){
      //   prod.CollectionName = "Others";
      // }
      // else if( this.CATEGORY=="Uni" ){
      //   prod.CollectionName = "Uni";
      // }
      // else if( this.CATEGORY=="Women" ){
      //   prod.CollectionName = "Women";
      // }
      // else if( this.CATEGORY=="Men" ){
      //   prod.CollectionName = "Men";
      // }


      this.productList.push(prod);

    }

    this.productListAvailable = true;

    






  }

  ngOnDestroy() {
    if(this.sub){
    this.sub.unsubscribe();}
  }

  // getFillSKUWithoutID() {
  //   this.collectionService.getAllItemBasic2VariationByItemProductTypeMainId(0)
  //     .subscribe((data: any) => {
  //       this.itemData = data.filter((test, index, array) => {
  //         return index === array.findIndex((findTest) =>
  //           findTest.SearchKeywordsWords === test.SearchKeywordsWords
  //         )
  //       });
  //       this.options = this.itemData.filter((option) => {
  //         return option.SearchKeywordsWords != null
  //       })
  //     });
  // }

  // onSeachDropdownValue($event) {
  //   const value = $event.target.value;
  //   this.filteredOptions1 = this.filter1(value);
  // }

  // filter1(name: string) {
  //   const filterValue = name.toLowerCase();
  //   return this.options.filter(
  //     (option) => option.SearchKeywordsWords.toLowerCase().indexOf(filterValue) === 0
  //   );
  // }

  // onSelectDropdownValue(option) {
  //   this.searchKey = option.SearchKeywordsWords;
  //   this.filteredOptions1 = [];
  //   this.GetAllProductsBySearchKeywordsWords(this.searchKey);
  // }


  

quickView(collectionName) {
  this.showQuickView = false;
  const skus = collectionName.split("&")[0];
  this._SKUCODE_=collectionName.split("&")[0];
  const collection = collectionName.split("&")[1];
  this.currentQuickView = null;
  switch (collection) {
    case "PRODUCT":
      this.productList.forEach((item) => {
          if (item.SKUCode == skus) {
            this.currentQuickView = item;
            this.showQuickView = true;
          }
      });
      break;

    default:
      break;

  }

}






}


